import { render, staticRenderFns } from "./survey-step-erectile-dysfunction.vue?vue&type=template&id=4e88d80c"
import script from "./survey-step-erectile-dysfunction.vue?vue&type=script&lang=js"
export * from "./survey-step-erectile-dysfunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports